module.exports = __webpack_public_path__ + "img/6.02c9e01c.png";